import React, { useEffect, useState } from "react";
import { message, Popconfirm, Tooltip } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { Folder } from "../../redux/interfaces/folder.types.ts";
import { completeFileFolder } from "../../redux/actions/folderActions.tsx";
import { useAppDispatch } from "../../redux/hooks.ts";
import { folderExceptions } from "../../exceptions/default/folderExceptions.ts";
import { extractErrorMessage } from "../../utils/extractErrorMessage.ts";

interface CompleteFolderProps {
  folder: Folder;
  isAdminOrOps: boolean;
  subFoldersAreReady: boolean;
}

export const CompleteFolder: React.FC<CompleteFolderProps> = ({
  folder,
  isAdminOrOps,
  subFoldersAreReady,
}) => {
  const [isIconViewValidated, setIsIconViewValidated] = useState(false);
  const dispatch = useAppDispatch();
  const [messageApi, contextHolder] = message.useMessage();

  const tooltipTitle = !isAdminOrOps
    ? folderExceptions.isNotAdminOrOps
    : !subFoldersAreReady
      ? folderExceptions.subfoldersAreNotReady
      : !folder.analysis
        ? folderExceptions.folderAnalysis
        : "Completar reporte de inquilino";

  const handlePreview = async () => {
    try {
      await dispatch(completeFileFolder(folder.folder_number)).unwrap();

      messageApi.success("El reporte del inquilino se ha completado con éxito");
    } catch (error: any) {
      messageApi.error(extractErrorMessage(error, "No se pudo completar el reporte."));
    }
  };

  const handleOnConfirm = () => {
    handlePreview();
  };

  useEffect(() => {
    setIsIconViewValidated(
      isAdminOrOps && subFoldersAreReady && !!folder.analysis,
    );
  }, [isAdminOrOps, subFoldersAreReady, folder.analysis]);

  return (
    <div>
      {contextHolder}
      <Popconfirm
        title="Completar reporte"
        description="¿Desea completar el reporte de inquilino?"
        placement="bottom"
        onConfirm={handleOnConfirm}
        disabled={!isIconViewValidated}
      >
        <Tooltip
          title={tooltipTitle}
          className={`${!isIconViewValidated ? null : "cursor-pointer"}`}
        >
          <CheckCircleFilled
            className={`h-6 w-6 text-xl ${folder.is_multireport_delivered ? "text-gray-600 hover:text-blue-400" : !isIconViewValidated ? "text-gray-300" : "text-gray-600 hover:text-green-400"}`}
          />
        </Tooltip>
      </Popconfirm>
    </div>
  );
};
